import React from "react";
import { Tooltip } from "react-tooltip";

export function BettingTypeToolTip(props: {
	name: string;
	description: string;
}) {
	const { name, description } = props;

	return (
		<Tooltip
			id={"offerRowTooltip-" + name.replace(" ", "")}
			className="at-bettingTypeToolTip react-tooltip--primary react-tooltip--table"
			place="right"
		>
			<div className="react-tooltip__header">{name}</div>
			<div className="react-tooltip__body">{description}</div>
		</Tooltip>
	);
}
